module.exports = __webpack_public_path__ + "img/lr2.7fb939e2.png";